<template>
    <div class="workflow-files-page">
        <!-- 顶部返回按钮 -->
        <div>
            <el-button type="text" icon="el-icon-back" @click="goBack" class="back-button">
                返回项目列表
            </el-button>
        </div>
        <!-- 顶部滑动选择框 -->
        <div class="top-tabs">
            <div class="tab-item" :class="{ active: activeTab === 'video' }" @click="activeTab = 'video'">
                <i class="el-icon-video-camera"></i>
                <span>视频</span>
            </div>
            <div class="tab-item" :class="{ active: activeTab === 'music' }" @click="activeTab = 'music'">
                <i class="el-icon-headset"></i>
                <span>音乐</span>
            </div>
            <div class="tab-item" :class="{ active: activeTab === 'subtitle' }" @click="activeTab = 'subtitle'">
                <i class="el-icon-tickets"></i>
                <span>字幕</span>
            </div>
            <div class="tab-item" :class="{ active: activeTab === 'settings' }" @click="activeTab = 'settings'">
                <i class="el-icon-setting"></i>
                <span>设置</span>
            </div>
        </div>

        <!-- 中间内容区域 -->
        <el-container class="content-container">
            <!-- 视频 Tab -->
            <template v-if="activeTab === 'video'">
                <!-- 左侧：文件夹 -->
                <el-aside width="280px" class="folders-aside">
                    <div class="aside-header">
                        <span>文件夹</span>
                        <div class="aside-actions">
                            <el-button size="mini" type="primary" @click="createFolder"
                                :disabled="!itemid">新建</el-button>
                        </div>
                    </div>
                    <div class="folders-scroll-container" @scroll="handleFoldersScroll">
                        <div class="folders-grid">
                            <div v-for="folder in folders" :key="folder.id" class="folder-card"
                                :class="{ active: folder.id === selectedFolderId }" @click="selectFolder(folder.id)">
                                <div class="folder-cover-wrapper">
                                    <el-image class="folder-cover" :src="folder.coverUrl || ''" fit="cover">
                                        <div slot="error" class="image-slot">
                                            <i class="el-icon-folder"></i>
                                        </div>
                                    </el-image>
                                    <div v-if="folder.useNum > 0" class="folder-use-badge">{{ folder.videoCount || 0
                                        }}个视频
                                    </div>
                                </div>
                                <div class="folder-meta">
                                    <div class="folder-name-row">
                                        <div class="folder-name" :title="folder.name">{{ folder.name }}</div>
                                        <div class="folder-actions" @click.stop>
                                            <el-dropdown trigger="click" @command="cmd => onFolderCommand(cmd, folder)">
                                                <span class="el-dropdown-link">
                                                    <i class="el-icon-more"></i>
                                                </span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item command="rename">重命名</el-dropdown-item>
                                                    <el-dropdown-item command="delete" divided>删除</el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </div>
                                    </div>
                                    <div class="folder-settings">
                                        <div class="folder-setting-item">
                                            <span class="setting-text">使用数量：</span>
                                            <span class="setting-value">{{ folder.useNum || 0 }}</span>
                                        </div>
                                        <div class="folder-setting-item">
                                            <span class="setting-text">截取时间：</span>
                                            <span class="setting-value">{{ folder.cutTime || 0 }}秒</span>
                                        </div>
                                        <div class="folder-setting-item">
                                            <span class="setting-text">截取方式：</span>
                                            <span class="setting-value">{{ folder.cutTimeType === 0 ? '从开头开始' : '随机时间'
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 加载更多提示 -->
                        <div v-if="foldersLoadingMore" class="folders-loading-more">
                            <i class="el-icon-loading"></i> 加载中...
                        </div>
                        <div v-if="foldersCurrentPage >= foldersLastPage && folders.length > 0"
                            class="folders-load-more-end">
                            已加载全部
                        </div>
                    </div>
                </el-aside>

                <!-- 右侧：文件列表 -->
                <el-main class="files-main">
                    <el-card shadow="never" class="files-card">
                        <div slot="header" class="clearfix files-card-header">
                            <div class="files-header-left">
                                <span>{{ currentFolder ? currentFolder.name : '' }} 视频列表</span>

                            </div>
                            <div class="files-header-right">
                                <el-button size="mini" type="primary" icon="el-icon-upload" @click="uploadFile"
                                    :disabled="!currentFolder">上传视频</el-button>
                                <el-input v-model="fileKeyword" placeholder="搜索视频名称" size="small" clearable
                                    style="width: 220px;" />
                            </div>
                        </div>

                        <!-- 文件夹使用设置信息 -->
                        <div v-if="currentFolder" class="folder-settings-info">
                            <div class="setting-item">
                                <i class="el-icon-video-play"></i>
                                <span class="setting-label">使用视频数量：</span>
                                <el-input-number v-model="currentFolder.useNum" :min="0" :max="999" size="mini"
                                    controls-position="right" style="width: 100px;" />
                                <span class="setting-unit">个</span>
                            </div>
                            <div class="setting-item">
                                <i class="el-icon-s-operation"></i>
                                <span class="setting-label">截取方式：</span>
                                <el-select v-model="currentFolder.cutTimeType" size="mini" style="width: 120px;">
                                    <el-option label="从开头开始" :value="0"></el-option>
                                    <el-option label="随机时间" :value="1"></el-option>
                                </el-select>
                            </div>
                            <div class="setting-item">
                                <i class="el-icon-time"></i>
                                <span class="setting-label">截取时间：</span>
                                <el-input-number v-model="currentFolder.cutTime" :min="0" :max="999" :step="0.1"
                                    :precision="2" size="mini" controls-position="right" style="width: 100px;" />
                                <span class="setting-unit">秒（0为完整视频）</span>
                            </div>

                        </div>

                        <div class="files-scroll">
                            <el-table :data="filteredFiles" size="small" border v-loading="filesLoading"
                                empty-text="暂无视频">
                                <el-table-column label="预览" width="90" align="center">
                                    <template slot-scope="scope">
                                        <div class="file-thumb-wrapper" @click="previewFile(scope.row)">
                                            <el-image :src="scope.row.thumbUrl || ''" fit="cover" class="file-thumb">
                                                <div slot="error" class="image-slot-small">
                                                    <i class="el-icon-document"></i>
                                                </div>
                                            </el-image>
                                            <div class="file-thumb-overlay">
                                                <i class="el-icon-video-play"></i>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="name" label="视频名称" min-width="220"
                                    show-overflow-tooltip></el-table-column>
                                <el-table-column prop="sizeText" label="时长" width="100"></el-table-column>
                                <el-table-column prop="uploadedAt" label="上传时间" width="160"></el-table-column>
                                <el-table-column label="操作" width="120" align="center">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="mini"
                                            @click="downloadFile(scope.row)">下载</el-button>
                                        <el-button type="text" size="mini" style="color:#f56c6c;"
                                            @click="deleteFile(scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="files-footer">
                                <div class="files-total">共 {{ filteredFiles.length }} 个视频</div>
                            </div>
                        </div>

                    </el-card>
                </el-main>
            </template>

            <!-- 音乐 Tab -->
            <el-main v-if="activeTab === 'music'" class="files-main-full">
                <el-card shadow="never" class="files-card">
                    <div slot="header" class="clearfix files-card-header">
                        <div class="files-header-left">
                            <span>音乐列表</span>
                        </div>
                        <div class="files-header-right">
                            <el-button size="mini" type="primary" icon="el-icon-upload"
                                @click="uploadFile">上传音乐</el-button>
                            <el-input v-model="fileKeyword" placeholder="搜索音乐名称" size="small" clearable
                                style="width: 220px;" />
                        </div>
                    </div>
                    <div class="files-scroll">
                        <el-table :data="filteredFiles" size="small" border v-loading="filesLoading" empty-text="暂无音乐"
                            style="width: 100%">
                            <el-table-column label="预览" width="90" align="center">
                                <template slot-scope="scope">
                                    <i class="el-icon-headset" style="font-size: 24px; color: #409eff;"></i>
                                </template>
                            </el-table-column>
                            <el-table-column prop="duration" label="时长" min-width="120"></el-table-column>
                            <el-table-column prop="time" label="上传时间" min-width="180"></el-table-column>
                            <el-table-column label="操作" min-width="200" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="mini" @click="previewFile(scope.row)">播放</el-button>
                                    <el-button type="text" size="mini" @click="downloadFile(scope.row)">下载</el-button>
                                    <el-button type="text" size="mini" style="color:#f56c6c;"
                                        @click="deleteFile(scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="files-footer">
                            <div class="files-total">共 {{ filteredFiles.length }} 个音乐</div>
                        </div>
                    </div>
                </el-card>
            </el-main>

            <!-- 字幕 Tab -->
            <el-main v-if="activeTab === 'subtitle'" class="files-main-full">
                <el-card shadow="never" class="files-card">
                    <div slot="header" class="clearfix files-card-header">
                        <div class="files-header-left">
                            <span>字幕列表</span>
                            <span class="files-total-inline">共 {{ filteredFiles.length }} 个字幕</span>
                        </div>
                        <div class="files-header-right">
                            <el-button size="mini" type="primary" icon="el-icon-plus"
                                @click="showSubtitleDialog">新建字幕</el-button>
                            <el-input v-model="fileKeyword" placeholder="搜索字幕名称" size="small" clearable
                                style="width: 220px;" />
                        </div>
                    </div>
                    <div class="files-scroll" v-loading="filesLoading">
                        <div v-if="filteredFiles.length === 0" class="empty-text">暂无字幕</div>
                        <div v-else class="subtitle-card-list">
                            <div v-for="(item, index) in filteredFiles" :key="index" class="subtitle-card-item"
                                @click="previewSubtitle(item)">
                                <div class="subtitle-card-content">
                                    <div class="subtitle-preview-text">
                                        <i class="el-icon-tickets" style="color: #67c23a; margin-right: 8px;"></i>
                                        <span>{{ getSubtitlePreviewText(item) }}</span>
                                    </div>
                                    <div class="subtitle-card-meta">
                                        <span class="subtitle-time">{{ item.uploadedAt || item.time || '-'
                                        }}</span>
                                    </div>
                                </div>
                                <div class="subtitle-card-actions" @click.stop>
                                    <el-button type="text" size="mini" style="color:#f56c6c;"
                                        @click="deleteSubtitle(item)">删除</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-main>

            <!-- 设置 Tab -->
            <el-main v-if="activeTab === 'settings'" class="files-main-full">
                <el-card shadow="never" class="files-card">
                    <div slot="header" class="clearfix">
                        <span>项目设置</span>
                    </div>
                    <div class="settings-content">
                        <el-form label-width="120px" size="small">
                            <el-form-item label="项目ID：">
                                <span>{{ itemid }}</span>
                            </el-form-item>
                            <el-form-item label="项目名称：">
                                <el-input v-model="projectSettings.name" placeholder="请输入项目名称"
                                    style="width: 400px;"></el-input>
                            </el-form-item>
                            <el-form-item label="项目描述：">
                                <el-input type="textarea" v-model="projectSettings.description" :rows="4"
                                    placeholder="请输入项目描述" style="width: 400px;"></el-input>
                            </el-form-item>

                            <!-- 视频时间 -->
                            <el-form-item label="视频时间：">
                                <div class="setting-description">跟随音乐会默认自动调整视频时间,且可能部分视频不显示</div>
                                <el-radio-group v-model="projectSettings.time_type">
                                    <el-radio :label="1">跟随音乐</el-radio>
                                    <el-radio :label="0">跟随视频</el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <!-- 视频原声 -->
                            <el-form-item label="视频原声：">
                                <div class="setting-description">视频片段原始声音,如开第一段视频时间从第二段开始计时</div>
                                <el-radio-group v-model="projectSettings.original_sound">
                                    <el-radio :label="1">全开启</el-radio>
                                    <el-radio :label="2">开第一段</el-radio>
                                    <el-radio :label="0">全关闭</el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <!-- 视频转场 -->
                            <el-form-item label="视频转场：">
                                <div class="setting-description">适合不需要音频的混剪,目前只建议搞笑视频</div>
                                <el-radio-group v-model="projectSettings.zc">
                                    <el-radio :label="1">开启</el-radio>
                                    <el-radio :label="0">关闭</el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <!-- 高级设置 -->
                            <el-divider>高级设置</el-divider>

                            <!-- 掐头去尾 -->
                            <el-form-item label="掐头去尾：">
                                <div class="setting-description">掐头去尾,去掉闪屏可使视频更流畅更美观</div>
                                <el-radio-group v-model="projectSettings.qtqw">
                                    <el-radio :label="1">开启</el-radio>
                                    <el-radio :label="0">关闭</el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <!-- 随机镜像 -->
                            <el-form-item label="随机镜像：">
                                <div class="setting-description">随机对片段进行镜像</div>
                                <el-radio-group v-model="projectSettings.sjjx">
                                    <el-radio :label="1">开启</el-radio>
                                    <el-radio :label="0">关闭</el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <el-form-item label="创建时间：">
                                <span>{{ projectSettings.createTime }}</span>
                            </el-form-item>
                            <el-form-item label="最后修改时间：">
                                <span>{{ projectSettings.updateTime }}</span>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
            </el-main>
        </el-container>

        <!-- 保存设置按钮 -->
        <div v-if="currentFolder || activeTab === 'settings'" class="save-settings-container">
            <el-button type="primary" icon="el-icon-check" @click="saveSettings" :loading="savingSettings"
                style="width: 100%;">
                保存设置
            </el-button>
            <el-button type="primary" icon="el-icon-scissors" :loading="savingSettings"
                style="width: 100%;color: #fff;background-color: #4f5adc;border-color: #4f5adc;">
                制作视频
            </el-button>
        </div>

        <!-- 编辑字幕对话框 -->
        <el-dialog :title="currentSubtitleId ? '编辑字幕' : '新建字幕'" :visible.sync="subtitleDialogVisible" width="800px"
            :close-on-click-modal="false">
            <div class="subtitle-dialog-content">
                <div class="subtitle-list">
                    <div v-for="(subtitle, index) in subtitleFormList" :key="index" class="subtitle-item">
                        <div class="subtitle-item-header">
                            <span class="subtitle-item-title">字幕 {{ index + 1 }}</span>
                            <el-button v-if="subtitleFormList.length > 1" type="text" icon="el-icon-delete" size="mini"
                                style="color: #f56c6c;" @click="removeSubtitle(index)">删除</el-button>
                        </div>
                        <el-form :model="subtitle" label-width="100px" size="small">
                            <el-form-item label="字幕文本：">
                                <el-input v-model="subtitle.text" placeholder="请输入字幕文本" maxlength="200"
                                    show-word-limit></el-input>
                            </el-form-item>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="开始时间：">
                                        <el-input-number v-model="subtitle.startTime" :step="0.1" :precision="2"
                                            controls-position="right" style="width: 100%;" placeholder="秒">
                                            <template slot="append">秒</template>
                                        </el-input-number>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="结束时间：">
                                        <el-input-number v-model="subtitle.endTime" :step="0.1" :precision="2"
                                            controls-position="right" style="width: 100%;" placeholder="秒">
                                            <template slot="append">秒</template>
                                        </el-input-number>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item label="位置：">
                                <el-radio-group v-model="subtitle.position">
                                    <el-radio :label="1">上部</el-radio>
                                    <el-radio :label="2">居中</el-radio>
                                    <el-radio :label="3">下部</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="subtitle-actions">
                    <el-button type="primary" icon="el-icon-plus" size="small" @click="addSubtitle">新增字幕</el-button>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelSubtitleDialog">取消</el-button>
                <el-button type="primary" @click="saveSubtitle" :loading="savingSubtitle">保存</el-button>
            </div>
        </el-dialog>

        <!-- 上传文件对话框 -->
        <el-dialog :title="uploadDialogTitle" :visible.sync="uploadDialogVisible" width="800px"
            :close-on-click-modal="false">
            <div style="font-size: 14px;">
                <cosupload ref="cosupload" upload_class="sck" :uploadkey="uploadkey"
                    @upload-success="handleUploadSuccess">
                </cosupload>
            </div>
        </el-dialog>

        <!-- 媒体预览组件 -->
        <LookVideo :visible.sync="mediaPreviewVisible" :media-src="currentMediaSrc" :media-name="currentMediaName"
            @download="handleMediaDownload" />
    </div>
</template>

<script>
import LookVideo from '@/components/common/lookvideo.vue'
import cosupload from '@/components/common/cosupload.vue'

export default {
    name: 'WorkflowFiles',
    components: {
        LookVideo,
        cosupload
    },
    data() {
        return {
            activeTab: 'video',
            folders: [],
            selectedFolderId: '',
            files: [],
            fileKeyword: '',
            filesLoading: false,
            savingSettings: false,
            lastSaveTime: 0, // 上次保存时间，用于节流
            // 文件夹分页相关
            foldersCurrentPage: 1, // 当前页
            foldersLastPage: 1, // 最后一页
            foldersPerPage: 10, // 每页数量
            foldersTotal: 0, // 总数
            foldersLoadingMore: false, // 是否正在加载更多
            projectSettings: {
                name: '',
                description: '',
                createTime: '',
                updateTime: '',
                // 视频时间：0-跟随视频，1-跟随音乐
                time_type: 1,
                // 视频原声：0-全关闭，1-全开启，2-开第一段
                original_sound: 0,
                // 视频之间加入转场：0-关闭，1-开启
                zc: 0,
                // 掐头去尾：0-关闭，1-开启
                qtqw: 0,
                // 随机镜像：0-关闭，1-开启
                sjjx: 0
            },
            musicList: [], // 音乐列表
            subtitleList: [], // 字幕列表
            subtitleDialogVisible: false, // 字幕对话框显示状态
            subtitleFormList: [], // 字幕表单列表
            savingSubtitle: false, // 保存字幕加载状态
            currentSubtitleId: null, // 当前编辑的字幕id（用于判断是更新还是新增）
            musicListLoaded: false, // 音乐列表是否已加载
            subtitleListLoaded: false, // 字幕列表是否已加载
            mediaPreviewVisible: false, // 媒体预览组件显示状态
            currentMediaSrc: '', // 当前预览的媒体地址
            currentMediaName: '', // 当前预览的媒体名称
            currentMediaFile: null, // 当前预览的媒体文件对象
            uploadDialogVisible: false, // 上传对话框显示状态,
            uploadkey: '',//上传地址
            coverRetryTimers: {}, // 封面重试定时器 {videoId: timerId}
        }
    },
    computed: {
        itemid() {
            return this.$route.query.id || ''
        },
        currentFolder() {
            return this.folders.find(f => f.id === this.selectedFolderId)
        },
        uploadDialogTitle() {
            return this.uploadFrom === 'music' ? '上传音乐' : '上传视频'
        },
        filteredFiles() {
            // 根据当前 tab 返回不同的文件列表
            if (this.activeTab === 'video') {
                if (!this.selectedFolderId) return []
                let result = Array.isArray(this.files) ? this.files.filter(f => f.folderId === this.selectedFolderId) : []
                if (!this.fileKeyword) return result
                const kw = this.fileKeyword.toLowerCase()
                return result.filter(f => f.name && f.name.toLowerCase().includes(kw))
            } else if (this.activeTab === 'music') {
                let result = Array.isArray(this.musicList) ? this.musicList : []
                if (!this.fileKeyword) return result
                const kw = this.fileKeyword.toLowerCase()
                return result.filter(f => f.name && f.name.toLowerCase().includes(kw))
            } else if (this.activeTab === 'subtitle') {
                let result = Array.isArray(this.subtitleList) ? this.subtitleList : []
                if (!this.fileKeyword) return result
                const kw = this.fileKeyword.toLowerCase()
                return result.filter(f => {
                    const previewText = this.getSubtitlePreviewText(f)
                    return previewText && previewText.toLowerCase().includes(kw)
                })
            }
            return []
        },
    },
    watch: {
        itemid: {
            handler(newVal, oldVal) {
                // 只有当 itemid 存在且变化时才加载，避免重复请求
                if (newVal && (oldVal === undefined || newVal !== oldVal)) {
                    // 重置加载标志位，以便重新加载数据
                    this.musicListLoaded = false
                    this.subtitleListLoaded = false
                    this.loadProjectData()
                }
            },
            immediate: true
        },
        activeTab(newTab) {
            // 切换 tab 时只在首次加载数据
            console.log('切换 tab:', newTab, 'musicListLoaded:', this.musicListLoaded, 'subtitleListLoaded:', this.subtitleListLoaded)
            if (newTab === 'music' && !this.musicListLoaded) {
                console.log('触发音乐列表加载')
                this.loadMusicList()
            } else if (newTab === 'subtitle' && !this.subtitleListLoaded) {
                console.log('触发字幕列表加载')
                this.loadSubtitleList()
            } else if (newTab === 'music') {
                console.log('音乐列表已加载，跳过')
            } else if (newTab === 'subtitle') {
                console.log('字幕列表已加载，跳过')
            }
            // 修复设置页面的 radio 组件警告
            if (newTab === 'settings') {
                this.$nextTick(() => {
                    this.$el.querySelectorAll('.el-radio__original[aria-hidden="true"]').forEach(el => el.removeAttribute('aria-hidden'))
                })
            }
        }
    },
    beforeDestroy() {
        // 清理所有封面重试定时器
        Object.keys(this.coverRetryTimers).forEach(key => {
            if (this.coverRetryTimers[key]) {
                clearTimeout(this.coverRetryTimers[key])
            }
        })
        this.coverRetryTimers = {}
    },
    methods: {
        goBack() {
            // 返回目录列表
            this.$router.push('/user/workflow')
        },
        async loadProjectData(reset = true) {
            const itemid = this.itemid
            if (!itemid) return

            // 如果是重置，重置分页信息
            if (reset) {
                this.foldersCurrentPage = 1
                this.folders = []
            }

            // 如果是加载更多，使用加载更多的状态
            if (!reset) {
                this.foldersLoadingMore = true
            } else {
                this.filesLoading = true
            }

            try {
                // 并行加载文件夹列表和项目详情（只在重置时加载项目详情）
                const promises = [
                    this.$ajax.get(`qhy/sck/sck_dir_list?itemid=${itemid}&page=${this.foldersCurrentPage}`)
                ]
                if (reset) {
                    promises.push(this.loadProjectInfo(itemid))
                }

                const results = await Promise.all(promises)
                const dirRes = results[0]

                console.log('视频文件夹列表返回:', dirRes.data)

                if (dirRes.data.status === 200) {
                    const responseData = dirRes.data.data || {}
                    // 适配分页信息
                    this.foldersCurrentPage = responseData.current_page || responseData.currentPage || 1
                    this.foldersLastPage = responseData.last_page || responseData.lastPage || 1
                    this.foldersPerPage = responseData.per_page || responseData.perPage || 10
                    this.foldersTotal = responseData.total || 0

                    // 数据在 data.data 中
                    const listData = responseData.data || []

                    // 保存当前选中的文件夹ID（只在重置时）
                    const currentSelectedId = reset ? this.selectedFolderId : null

                    // 解析文件夹列表（按 sort 排序）
                    const newFolders = listData
                        .sort((a, b) => a.sort - b.sort)
                        .map((dir, index) => ({
                            id: dir.id,
                            name: dir.name || `文件夹 ${dir.sort + 1}`,
                            coverUrl: dir.video_list && dir.video_list.length > 0 ? dir.video_list[0].cover : '',
                            uploadedAt: this.formatTime(dir.time),
                            createdAt: this.formatTime(dir.time),
                            sort: dir.sort,
                            useNum: dir.use_num,
                            cutTimeType: dir.cut_time_type,
                            cutTime: dir.cut_time,
                            videoCount: dir.video_list ? dir.video_list.length : 0,
                            videoList: dir.video_list || [],
                            rawData: dir
                        }))

                    // 如果是重置，替换列表；如果是加载更多，追加到列表
                    if (reset) {
                        this.folders = newFolders
                    } else {
                        this.folders = [...this.folders, ...newFolders]
                    }

                    // 保持选中的文件夹不变，如果选中的文件夹不存在则选中第一个（只在重置时）
                    if (reset) {
                        if (this.folders.length > 0) {
                            // 检查之前选中的文件夹是否还存在
                            const selectedFolder = this.folders.find(f => f.id === currentSelectedId)
                            if (selectedFolder) {
                                // 保持选中之前的文件夹
                                this.selectedFolderId = currentSelectedId
                                this.loadFolderFiles(selectedFolder)
                            } else {
                                // 如果之前的文件夹不存在，选中第一个
                                this.selectedFolderId = this.folders[0].id
                                this.loadFolderFiles(this.folders[0])
                            }
                        } else {
                            this.selectedFolderId = ''
                            this.files = []
                        }
                    }
                } else {
                    this.$message.error(dirRes.data.msg || '加载失败')
                }
            } catch (err) {
                console.error('load folders error:', err)
                this.$message.error('加载文件夹列表失败')
            } finally {
                this.filesLoading = false
                this.foldersLoadingMore = false
            }
        },
        handleFoldersScroll(event) {
            const container = event.target
            // 计算是否滚动到底部（距离底部50px时触发）
            const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight
            if (scrollBottom < 50 && !this.foldersLoadingMore && this.foldersCurrentPage < this.foldersLastPage) {
                this.loadMoreFolders()
            }
        },
        async loadMoreFolders() {
            if (this.foldersLoadingMore || this.foldersCurrentPage >= this.foldersLastPage) {
                return
            }
            this.foldersCurrentPage++
            await this.loadProjectData(false)
        },
        async loadProjectInfo(itemid) {
            try {
                // 加载项目详情
                const res = await this.$ajax.get(`qhy/sck/sck_item_info?id=${itemid}`)
                console.log('项目详情返回:', res.data)
                if (res.data.status === 200) {
                    const data = res.data.data || {}

                    // 解析 other 字段（JSON 字符串）
                    let otherData = {}
                    if (data.other) {
                        try {
                            otherData = typeof data.other === 'string' ? JSON.parse(data.other) : data.other
                        } catch (e) {
                            console.error('解析 other 字段失败:', e)
                            otherData = {}
                        }
                    }

                    // 更新项目设置（顶层字段优先级高于 other 中的字段）
                    this.projectSettings = {
                        // 先设置默认值
                        time_type: 1,
                        original_sound: 0,
                        zc: 0,
                        qtqw: 0,
                        sjjx: 0,
                        // 然后合并 other 字段中的设置（会覆盖默认值）
                        ...otherData,
                        // 最后覆盖基础字段（确保顶层数据优先级）
                        name: data.name || otherData.name || '',
                        description: data.description || otherData.description || '',
                        createTime: data.time ? this.formatTime(data.time) : '',
                        updateTime: data.use_time ? this.formatTime(data.use_time) : '',
                        // 确保 other 字段中的参数有值（如果 otherData 中没有，使用默认值）
                        time_type: otherData.time_type !== undefined ? otherData.time_type : 1,
                        original_sound: otherData.original_sound !== undefined ? otherData.original_sound : 0,
                        zc: otherData.zc !== undefined ? otherData.zc : 0,
                        qtqw: otherData.qtqw !== undefined ? otherData.qtqw : 0,
                        sjjx: otherData.sjjx !== undefined ? otherData.sjjx : 0
                    }

                    console.log('项目设置已更新:', this.projectSettings)
                }
                return res
            } catch (err) {
                console.error('load project info error:', err)
                // 如果接口不存在，使用默认数据
                return { data: { status: 200, data: {} } }
            }
        },
        async loadMusicList() {
            const itemid = this.itemid
            if (!itemid || itemid === 'create') {
                console.log('音乐列表加载跳过：itemid 不存在')
                return
            }

            this.filesLoading = true
            console.log('开始加载音乐列表，itemid:', itemid)
            try {
                const res = await this.$ajax.post(`qhy/sck/sck_music_list?page=1`, {
                    itemid: itemid
                }, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                })
                console.log('音乐列表返回:', res.data)
                if (res.data.status === 200) {
                    this.musicList = res.data.data.data || []
                    this.musicListLoaded = true
                    console.log('音乐列表加载成功，数量:', this.musicList.length)
                } else {
                    console.error('音乐列表加载失败:', res.data.msg)
                }
            } catch (err) {
                console.error('load music list error:', err)
                this.musicList = []
            } finally {
                this.filesLoading = false
            }
        },
        async loadSubtitleList() {
            const itemid = this.itemid
            if (!itemid || itemid === 'create') return

            this.filesLoading = true
            try {
                const res = await this.$ajax.get(`qhy/sck/sck_subtitle_list?itemid=${itemid}`)
                if (res.data.status === 200) {
                    this.subtitleList = res.data.data || []
                    this.subtitleListLoaded = true
                }
            } catch (err) {
                console.error('load subtitle list error:', err)
                this.subtitleList = []
            } finally {
                this.filesLoading = false
            }
        },
        formatTime(timestamp) {
            if (!timestamp) return ''
            const date = new Date(timestamp * 1000)
            return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })
        },
        formatDuration(seconds) {
            if (!seconds) return '0秒'
            const mins = Math.floor(seconds / 60)
            const secs = Math.floor(seconds % 60)
            if (mins > 0) {
                return `${mins}分${secs}秒`
            }
            return `${secs}秒`
        },
        loadFolderFiles(folder) {
            // 根据文件夹加载视频列表
            if (!folder || !folder.videoList) {
                this.files = []
                return
            }

            this.files = folder.videoList.map((video, index) => {
                // 如果没有名称，尝试从 URL 提取文件名
                let videoName = video.name
                if (!videoName && video.url) {
                    const urlParts = video.url.split('/')
                    const fileName = urlParts[urlParts.length - 1]
                    videoName = fileName.replace(/\.(mp4|avi|mov|mkv)$/i, '')
                }
                if (!videoName) {
                    videoName = `视频${index + 1}`
                }

                return {
                    id: video.id,
                    folderId: folder.id,
                    name: videoName,
                    sizeText: this.formatDuration(video.duration),
                    uploadedAt: this.formatTime(video.time),
                    thumbUrl: video.cover || '',
                    url: video.url || '',
                    duration: video.duration,
                    rawData: video
                }
            })
        },
        selectFolder(folderId) {
            this.selectedFolderId = folderId
            const folder = this.folders.find(f => f.id === folderId)
            if (folder) {
                this.loadFolderFiles(folder)
            }
        },
        async createFolder() {
            if (!this.itemid) return
            try {
                const { value } = await this.$prompt('请输入文件夹名称', '新建文件夹', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                if (!value) return

                // 计算新的 sort 值（当前最大 sort + 1）
                const maxSort = this.folders.length > 0
                    ? Math.max(...this.folders.map(f => f.sort || 0))
                    : -1
                const newSort = maxSort + 1

                // 调用 API 创建文件夹
                const res = await this.$ajax.post('qhy/sck/sck_dir_add', {
                    itemid: this.itemid,
                    name: value,
                    sort: newSort,
                    use_num: 0,
                    cut_time: 0,
                    cut_time_type: 0,
                    video_list: []
                }, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                })
                console.log(res)
                if (res.data.status === 200) {
                    this.$message.success('文件夹已创建')

                    const folderData = {
                        itemid: this.itemid,
                        name: value,
                        sort: newSort,
                        use_num: 0,
                        cut_time: 0,
                        cut_time_type: 0,
                        video_list: [],
                        ...res.data.data
                    }

                    const newFolderId = folderData.id || `${Date.now()}`
                    const folderTime = folderData.time || Math.floor(Date.now() / 1000)
                    const videoList = Array.isArray(folderData.video_list) ? folderData.video_list : []

                    const newFolder = {
                        id: newFolderId,
                        name: folderData.name || value,
                        coverUrl: folderData.cover || '',
                        uploadedAt: this.formatTime(folderTime),
                        createdAt: this.formatTime(folderTime),
                        sort: folderData.sort !== undefined ? folderData.sort : newSort,
                        useNum: folderData.use_num !== undefined ? folderData.use_num : 0,
                        cutTimeType: folderData.cut_time_type !== undefined ? folderData.cut_time_type : 0,
                        cutTime: folderData.cut_time !== undefined ? folderData.cut_time : 0,
                        videoCount: videoList.length,
                        videoList: videoList,
                        rawData: folderData
                    }

                    this.folders.push(newFolder)
                    this.folders.sort((a, b) => (a.sort || 0) - (b.sort || 0))
                    this.foldersTotal = (this.foldersTotal || 0) + 1

                    this.selectedFolderId = newFolderId
                    this.loadFolderFiles(newFolder)
                } else {
                    this.$message.error(res.data.msg || '创建文件夹失败')
                }
            } catch (err) {
                if (err !== 'cancel') {
                    console.error('create folder error:', err)
                    this.$message.error('创建文件夹失败')
                }
            }
        },
        onFolderCommand(cmd, folder) {
            if (cmd === 'rename') {
                this.$prompt('请输入新的文件夹名称', '重命名文件夹', {
                    inputValue: folder.name,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    if (!value) return
                    // TODO: 调用 API 重命名文件夹
                    folder.name = value
                }).catch(() => { })
            } else if (cmd === 'delete') {
                this.delDir(folder)
            }
        },
        delDir(folder) {
            const videoList = folder.videoList || folder.video_list || []
            const videoCount = folder.videoCount || videoList.length || 0

            // 如果文件夹为空，直接删除（不显示确认对话框）
            if (videoCount < 1) {
                const folderIndex = this.folders.findIndex(f => f.id === folder.id)
                if (folderIndex !== -1) {
                    this.folders.splice(folderIndex, 1)
                    this.foldersTotal = Math.max(0, (this.foldersTotal || 0) - 1)

                    // 如果删除的是当前选中的文件夹，需要重新选择
                    if (this.selectedFolderId === folder.id) {
                        if (this.folders.length > 0) {
                            this.selectedFolderId = this.folders[0].id
                            this.loadFolderFiles(this.folders[0])
                        } else {
                            this.selectedFolderId = ''
                            this.files = []
                        }
                    }
                    this.$message.success('文件夹已删除')
                }
                return
            }

            // 如果文件夹有内容，显示确认对话框
            this.$confirm(`确定删除文件夹"${folder.name}"及其中的所有视频吗？删除后将不可恢复。`, '删除文件夹', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading(this.$loadinginfo)

                // 构建请求参数，传入 itemid 和 id（也可以直接传入整个 folder 对象）
                const data = {
                    itemid: this.itemid,
                    id: folder.id
                }

                this.$ajax.post('qhy/sck/del_dir', data, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(res => {
                    console.log('删除文件夹返回:', res.data)
                    loading.close()

                    if (res.data.status === 200) {
                        // 删除成功，从列表中移除
                        const folderIndex = this.folders.findIndex(f => f.id === folder.id)
                        if (folderIndex !== -1) {
                            this.folders.splice(folderIndex, 1)
                            this.foldersTotal = Math.max(0, (this.foldersTotal || 0) - 1)

                            // 如果删除的是当前选中的文件夹，需要重新选择
                            if (this.selectedFolderId === folder.id) {
                                if (this.folders.length > 0) {
                                    this.selectedFolderId = this.folders[0].id
                                    this.loadFolderFiles(this.folders[0])
                                } else {
                                    this.selectedFolderId = ''
                                    this.files = []
                                }
                            }
                        }
                        this.$message.success(res.data.msg || '文件夹已删除')
                    } else {
                        this.$message.error(res.data.msg || '删除失败')
                    }
                }).catch(err => {
                    console.error('删除文件夹失败:', err)
                    loading.close()
                    this.$message.error('删除文件夹失败，请稍后重试')
                })
            }).catch(() => {
                // 用户取消删除
            })
        },
        uploadFile() {
            // 根据当前 tab 设置上传类型
            //构建上传地址
            this.uploadkey = this.itemid + '/' + this.activeTab
            if (this.activeTab === 'music') {
                this.uploadFrom = 'music'
            } else if (this.activeTab === 'video') {
                // 视频上传需要检查是否有选中的文件夹
                if (!this.currentFolder) {
                    this.$message.warning('请先选择一个文件夹')
                    return
                }
                this.uploadFrom = 'video'
                this.uploadkey = this.uploadkey + this.currentFolder.id
            } else {
                return
            }
            // 打开上传对话框
            this.uploadDialogVisible = true
            console.log(this.uploadkey)
        },
        handleUploadSuccess(data) {
            // 处理上传成功事件
            console.log('上传成功:', data)
            // 如果是视频上传
            if (this.activeTab === 'video') {
                // 如果有 src_data，直接插入到当前文件夹，不需要刷新列表
                if (data.src_data && this.currentFolder) {
                    this.insertVideoToCurrentFolder(data.src_data)
                } else {
                    // 没有 src_data，刷新整个列表
                    this.loadProjectData()
                }
            } else if (this.activeTab === 'music') {
                // 如果是音乐上传，刷新音乐列表
                this.loadMusicList()
            }
        },
        insertVideoToCurrentFolder(srcData) {
            // 将 src_data 转换为视频列表格式并插入到当前文件夹
            if (!this.currentFolder || !srcData) {
                return
            }

            // 从 URL 提取文件名
            let videoName = ''
            if (srcData.url) {
                const urlParts = srcData.url.split('/')
                const fileName = urlParts[urlParts.length - 1]
                videoName = fileName.replace(/\.(mp4|avi|mov|mkv)$/i, '')
            }
            if (!videoName) {
                videoName = `视频${Date.now()}`
            }

            // 构建视频对象
            const newVideo = {
                id: srcData.id,
                folderId: this.currentFolder.id,
                name: videoName,
                sizeText: this.formatDuration(srcData.duration) || '0秒',
                uploadedAt: this.formatTime(srcData.time),
                thumbUrl: srcData.cover || '',
                url: srcData.url || '',
                duration: srcData.duration || 0,
                rawData: srcData
            }

            // 添加到文件列表
            this.files.push(newVideo)

            // 更新文件夹的视频列表
            if (!this.currentFolder.videoList) {
                this.currentFolder.videoList = []
            }
            this.currentFolder.videoList.push(srcData)

            // 更新文件夹的视频数量
            this.currentFolder.videoCount = (this.currentFolder.videoCount || 0) + 1

            // 更新文件夹的封面（如果当前没有封面）
            if (!this.currentFolder.coverUrl && srcData.cover) {
                this.currentFolder.coverUrl = srcData.cover
                // 对文件夹封面也进行重试加载
                this.loadCoverWithRetry(this.currentFolder, 'coverUrl', srcData.cover, true)
            }

            // 更新 folders 数组中对应的文件夹
            const folderIndex = this.folders.findIndex(f => f.id === this.currentFolder.id)
            if (folderIndex !== -1) {
                this.$set(this.folders, folderIndex, { ...this.currentFolder })
            }

            // 对视频封面进行重试加载
            if (srcData.cover) {
                this.loadCoverWithRetry(newVideo, 'thumbUrl', srcData.cover, false)
            }

            this.$message.success('视频已添加到当前文件夹')
        },
        loadCoverWithRetry(target, coverKey, coverUrl, isFolder = false, retryCount = 0, maxRetries = 30) {
            // 封面图片加载重试方法
            // target: 目标对象（视频或文件夹）
            // coverKey: 封面属性名（thumbUrl 或 coverUrl）
            // coverUrl: 封面URL
            // isFolder: 是否是文件夹封面
            // retryCount: 当前重试次数
            // maxRetries: 最大重试次数（30次，即30秒）

            if (!coverUrl || retryCount >= maxRetries) {
                // 达到最大重试次数，清理定时器
                const targetId = target.id
                const timerKey = `${isFolder ? 'folder' : 'video'}_${targetId}`
                if (this.coverRetryTimers[timerKey]) {
                    clearTimeout(this.coverRetryTimers[timerKey])
                    delete this.coverRetryTimers[timerKey]
                }
                return
            }

            const targetId = target.id
            const timerKey = `${isFolder ? 'folder' : 'video'}_${targetId}`

            // 清除之前的定时器
            if (this.coverRetryTimers[timerKey]) {
                clearTimeout(this.coverRetryTimers[timerKey])
            }

            // 创建图片对象来测试加载
            const img = new Image()
            // 第一次使用原始URL，重试时在URL后面添加时间戳参数来刷新缓存
            const testUrl = retryCount > 0
                ? coverUrl + (coverUrl.includes('?') ? '&' : '?') + '_t=' + Date.now()
                : coverUrl

            img.onload = () => {
                // 加载成功，更新封面URL
                if (isFolder) {
                    target.coverUrl = testUrl
                } else {
                    target.thumbUrl = testUrl
                }
                // 清除定时器
                if (this.coverRetryTimers[timerKey]) {
                    clearTimeout(this.coverRetryTimers[timerKey])
                    delete this.coverRetryTimers[timerKey]
                }
                // 如果是文件夹，更新 folders 数组
                if (isFolder) {
                    const folderIndex = this.folders.findIndex(f => f.id === target.id)
                    if (folderIndex !== -1) {
                        this.$set(this.folders, folderIndex, { ...target })
                    }
                }
                // 强制更新视图
                this.$forceUpdate()
            }

            img.onerror = () => {
                // 加载失败，1秒后重试
                this.coverRetryTimers[timerKey] = setTimeout(() => {
                    this.loadCoverWithRetry(target, coverKey, coverUrl, isFolder, retryCount + 1, maxRetries)
                }, 1000)
            }

            // 开始加载图片
            img.src = testUrl
        },
        deleteFile(file) {
            const fileType = this.activeTab === 'music' ? '音乐' : '视频'
            const fileName = file.name || '未命名'

            this.$confirm(`确定删除${fileType}"${fileName}"吗？删除后将不可恢复。`, `删除${fileType}`, {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delVideo(file)
            }).catch(() => { })
        },
        delVideo(file) {
            const loading = this.$loading(this.$loadinginfo)
            const isMusic = this.activeTab === 'music'
            const fileType = isMusic ? '音乐' : '视频'

            // 获取文件的原始数据（包含所有信息）
            const fileData = file.rawData || file

            this.$ajax.post('qhy/sck/del_video', fileData, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(res => {
                console.log(`删除${fileType}返回:`, res.data)
                loading.close()

                if (res.data.status === 200) {
                    if (isMusic) {
                        // 删除音乐：从 musicList 中移除
                        const musicIndex = this.musicList.findIndex(m => m.id === file.id)
                        if (musicIndex !== -1) {
                            this.musicList.splice(musicIndex, 1)
                        }
                    } else {
                        // 删除视频：从 files 数组中移除
                        const fileIndex = this.files.findIndex(f => f.id === file.id)
                        if (fileIndex !== -1) {
                            this.files.splice(fileIndex, 1)
                        }

                        // 从当前文件夹的 videoList 中移除
                        if (this.currentFolder && this.currentFolder.videoList) {
                            const videoIndex = this.currentFolder.videoList.findIndex(v => v.id === file.id)
                            if (videoIndex !== -1) {
                                this.currentFolder.videoList.splice(videoIndex, 1)
                                // 更新视频数量
                                this.currentFolder.videoCount = Math.max(0, (this.currentFolder.videoCount || 0) - 1)

                                // 更新文件夹封面（如果删除的是第一张）
                                if (videoIndex === 0 && this.currentFolder.videoList.length > 0) {
                                    const newFirstVideo = this.currentFolder.videoList[0]
                                    if (newFirstVideo && newFirstVideo.cover) {
                                        this.currentFolder.coverUrl = newFirstVideo.cover
                                        this.loadCoverWithRetry(this.currentFolder, 'coverUrl', newFirstVideo.cover, true)
                                    }
                                } else if (this.currentFolder.videoList.length === 0) {
                                    // 如果文件夹为空，清空封面
                                    this.currentFolder.coverUrl = ''
                                }

                                // 更新 folders 数组中的对应文件夹
                                const folderIndex = this.folders.findIndex(f => f.id === this.currentFolder.id)
                                if (folderIndex !== -1) {
                                    this.$set(this.folders, folderIndex, { ...this.currentFolder })
                                }
                            }
                        }
                    }

                    this.$message.success(res.data.msg || `${fileType}已删除`)
                } else {
                    this.$message.error(res.data.msg || '删除失败')
                }
            }).catch(err => {
                console.error(`删除${fileType}失败:`, err)
                loading.close()
                this.$message.error(`删除${fileType}失败，请稍后重试`)
            })
        },
        previewFile(file) {
            // 获取媒体地址和名称
            const mediaSrc = file.url || file.video || file.audio || ''
            const mediaName = file.name || '未命名'

            if (!mediaSrc) {
                this.$message.warning('媒体链接不存在')
                return
            }

            // 设置预览信息（媒体类型会根据 URL 后缀自动判断）
            this.currentMediaSrc = mediaSrc
            this.currentMediaName = mediaName
            this.currentMediaFile = file

            // 打开预览组件
            this.mediaPreviewVisible = true
        },
        handleMediaDownload() {
            // 调用原有的下载方法
            if (this.currentMediaFile) {
                this.downloadFile(this.currentMediaFile)
            }
        },
        downloadFile(file) {
            if (file.url || file.video || file.audio) {
                const mediaUrl = file.url || file.video || file.audio
                const link = document.createElement('a')
                link.href = mediaUrl
                link.download = file.name || (this.activeTab === 'music' ? 'audio.mp3' : 'video.mp4')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.$message.success('开始下载')
            } else {
                this.$message.warning(this.activeTab === 'music' ? '音频链接不存在' : '视频链接不存在')
            }
        },
        async saveSettings() {
            // 节流：限制每秒最多保存一次
            const now = Date.now()
            const timeSinceLastSave = now - this.lastSaveTime
            if (timeSinceLastSave < 1000) {
                const remainingTime = ((1000 - timeSinceLastSave) / 1000).toFixed(1)
                this.$message.warning(`操作过于频繁，请等待 ${remainingTime} 秒后再试`)
                return
            }

            // 更新上次保存时间
            this.lastSaveTime = now

            // 统一使用 save 方法保存所有设置
            await this.save()
        },
        async save() {
            console.log(this.itemid)

            if (this.itemid === 'create' || !this.itemid) {
                this.$message.warning('项目 ID 不存在，无法保存')
                return
            }

            // 从 projectSettings 中提取 other 字段（排除基础字段）
            // 注意：name、description、createTime、updateTime 不应该在 other 中，它们保存在顶层
            const { name, description, createTime, updateTime, ...otherSettings } = this.projectSettings

            // 构建视频文件夹数据（包含所有文件夹的设置：使用数量、截取时间、截取方式等）
            const videodir = this.folders.map(folder => {
                return {
                    id: folder.id,
                    name: folder.name,
                    use_num: folder.useNum || 0,        // 使用数量
                    cut_time: folder.cutTime || 0,      // 截取时间
                    cut_time_type: folder.cutTimeType || 0,  // 截取方式：0-从开头开始，1-随机时间
                    sort: folder.sort || 0,
                    video_list: folder.videoList || []  // 视频列表
                }
            })

            // 构建保存数据
            const data = {
                name: name || '',
                description: description || '',
                videodir: videodir,  // 视频文件夹列表（包含所有设置）
                id: this.itemid,
                videodir_num: videodir.length,
                music_num: this.musicList ? this.musicList.length : 0,
                // other 字段需要序列化为 JSON 字符串
                other: otherSettings
            }

            console.log('save', data)

            this.savingSettings = true
            try {
                const res = await this.$ajax.post('qhy/sck/item_updata', {
                    data: JSON.stringify(data)
                }, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                })

                console.log(res)

                if (res.data.status === 200) {
                    this.$message.success('保存成功')
                    // 可以触发事件通知父组件
                    this.$emit('saveSuccess', data)
                } else if (res.data.status === 101) {
                    // 处理状态 101 的情况
                    this.$message.warning(res.data.msg || '保存状态异常')
                } else {
                    this.$message.error(res.data.msg || '保存失败')
                }
            } catch (err) {
                console.error('save error:', err)
                this.$message.error('保存失败')
            } finally {
                this.savingSettings = false
            }
        },
        // 解析字幕列表为表单格式
        parseSubtitleList(subtitleData, subtitleId) {
            if (subtitleData.subtitle_list) {
                try {
                    const subtitleListStr = typeof subtitleData.subtitle_list === 'string'
                        ? subtitleData.subtitle_list
                        : JSON.stringify(subtitleData.subtitle_list)
                    const parsedList = JSON.parse(subtitleListStr)
                    return Array.isArray(parsedList) ? parsedList.map(sub => ({
                        id: subtitleId,
                        text: sub.text || '',
                        startTime: sub.start_time || sub.startTime || 0,
                        endTime: sub.end_time || sub.endTime || 0,
                        position: sub.position || 3
                    })) : []
                } catch (e) {
                    console.error('解析字幕列表失败:', e)
                    return []
                }
            }
            return [{
                id: subtitleId,
                text: subtitleData.text || '',
                startTime: subtitleData.start_time || subtitleData.startTime || 0,
                endTime: subtitleData.end_time || subtitleData.endTime || 0,
                position: subtitleData.position || 3
            }]
        },
        // 显示字幕对话框
        showSubtitleDialog() {
            if (this.subtitleList && this.subtitleList.length > 0) {
                const firstItem = this.subtitleList[0]
                this.currentSubtitleId = firstItem.id || null
                this.subtitleFormList = this.parseSubtitleList(firstItem, this.currentSubtitleId)
            } else {
                this.currentSubtitleId = null
                this.subtitleFormList = [{
                    id: null,
                    text: '',
                    startTime: 0,
                    endTime: 0,
                    position: 3
                }]
            }
            this.subtitleDialogVisible = true
        },
        // 预览字幕
        previewSubtitle(item) {
            this.currentSubtitleId = item.id || null
            this.subtitleFormList = this.parseSubtitleList(item, this.currentSubtitleId)
            this.subtitleDialogVisible = true
        },
        // 删除字幕
        deleteSubtitle(item) {
            this.$confirm(`确定删除该字幕吗？`, '删除字幕', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                // TODO: 调用删除 API
                this.$message.success('删除成功')
                await this.loadSubtitleList()
            }).catch(() => { })
        },
        // 获取字幕预览文本
        getSubtitlePreviewText(item) {
            const parsedList = this.parseSubtitleList(item, null)
            if (parsedList && parsedList.length > 0) {
                const text = parsedList[0].text || ''
                return text.length > 30 ? text.substring(0, 30) + '...' : text || '无字幕文本'
            }
            return '无字幕文本'
        },
        // 新增字幕项
        addSubtitle() {
            this.subtitleFormList.push({
                id: null,
                text: '',
                startTime: 0,
                endTime: 0,
                position: 3
            })
        },
        // 删除字幕项
        removeSubtitle(index) {
            this.subtitleFormList.splice(index, 1)
        },
        // 取消字幕对话框
        cancelSubtitleDialog() {
            this.subtitleDialogVisible = false
            this.subtitleFormList = []
            this.currentSubtitleId = null
        },
        // 保存字幕
        async saveSubtitle() {
            // 验证表单
            if (!this.subtitleFormList || this.subtitleFormList.length === 0) {
                this.$message.warning('请至少添加一个字幕')
                return
            }

            // 验证每个字幕项
            for (let i = 0; i < this.subtitleFormList.length; i++) {
                const subtitle = this.subtitleFormList[i]
                if (!subtitle.text || subtitle.text.trim() === '') {
                    this.$message.warning(`字幕 ${i + 1} 的文本不能为空`)
                    return
                }
                if (subtitle.endTime <= subtitle.startTime) {
                    this.$message.warning(`字幕 ${i + 1} 的结束时间必须大于开始时间`)
                    return
                }
            }

            if (!this.itemid || this.itemid === 'create') {
                this.$message.warning('项目 ID 不存在，无法保存')
                return
            }

            const subtitleList = this.subtitleFormList.map(item => ({
                text: item.text,
                start_time: item.startTime,
                end_time: item.endTime,
                position: item.position
            }))

            const isUpdate = this.currentSubtitleId !== null && this.currentSubtitleId !== undefined

            console.log('字幕保存信息:', {
                currentSubtitleId: this.currentSubtitleId,
                isUpdate: isUpdate,
                total: subtitleList.length,
                subtitle_list: subtitleList
            })

            this.savingSubtitle = true
            try {
                const params = {
                    itemid: this.itemid,
                    subtitle_list: JSON.stringify(subtitleList)
                }
                if (isUpdate) {
                    params.subtitle_id = this.currentSubtitleId
                }

                const res = await this.$ajax.post('qhy/sck/sck_subtitle_save', params, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                })
                console.log('字幕保存返回:', res.data)
                if (res.data.status === 200) {
                    if (res.data.data && res.data.data.id) {
                        this.currentSubtitleId = res.data.data.id
                    }
                    this.$message.success(isUpdate ? '更新成功' : '保存成功')
                    this.subtitleDialogVisible = false
                    this.subtitleFormList = []
                    await this.loadSubtitleList()
                } else {
                    this.$message.error(res.data.msg || '保存失败')
                }
            } catch (err) {
                console.error('save subtitle error:', err)
                this.$message.error('保存字幕失败')
            } finally {
                this.savingSubtitle = false
            }
        },
    }
}
</script>

<style scoped>
.workflow-files-page {
    padding: 4px;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 100px);
}

.back-button {
    color: #409eff;
    font-size: 14px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    transition: all 0.3s ease;
}

.back-button:hover {
    color: #66b1ff;
    background-color: rgba(64, 158, 255, 0.1);
    border-radius: 4px;
}

.back-button i {
    font-size: 16px;
}

/* 顶部滑动选择框 */
.top-tabs {
    display: flex;
    gap: 4px;
    background: #f5f7fa;
    padding: 6px;
    border-radius: 8px;
    margin-bottom: 10px;
}

.tab-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 16px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #e8eaed;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
    user-select: none;
}

.tab-item i {
    font-size: 16px;
}

.tab-item:hover {
    background: rgba(64, 158, 255, 0.1);
    color: #409eff;
}

.tab-item.active {
    background: #409eff;
    color: #fff;
    box-shadow: 0 2px 12px rgba(64, 158, 255, 0.4);
}

/* 中间内容区域 */
.content-container {
    flex: 1;
    overflow: hidden;
}

.content-container>>>.el-container {
    overflow: hidden;
    height: 100%;
}

.content-container>>>.el-main {
    overflow: hidden !important;
}

.folders-aside {
    background: #fff;
    border-right: 1px solid #f0f0f0;
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.folders-scroll-container {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
}

.aside-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
}

.aside-actions {
    display: inline-flex;
    gap: 6px;
}

.folders-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(70px, auto);
    gap: 8px;
    padding-bottom: 10px;
}

.folders-loading-more {
    text-align: center;
    padding: 10px;
    color: #909399;
    font-size: 12px;
}

.folders-load-more-end {
    text-align: center;
    padding: 10px;
    color: #c0c4cc;
    font-size: 12px;
}

.folder-card {
    position: relative;
    display: grid;
    grid-template-columns: 60px 1fr;
    gap: 8px;
    padding: 6px;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    cursor: pointer;
    background: #fff;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
    align-items: stretch;
}

.folder-name-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-width: 0;
    overflow: hidden;
}

.folder-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.folder-actions .el-dropdown-link {
    color: #909399;
    padding: 2px 4px;
}

.folder-card:hover .el-dropdown-link {
    color: #606266;
}

.folder-card:hover {
    border-color: #dcdfe6;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.folder-card.active {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}

.folder-cover-wrapper {
    position: relative;
    width: 60px;
    height: 80px;
    /* min-height: 46px; */
    display: flex;
    align-items: stretch;
}

.folder-cover-wrapper>>>.el-image {
    width: 100%;
    height: 100%;
}

.folder-cover-wrapper>>>.el-image__inner {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.folder-cover {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    background: #fafafa;
    object-fit: cover;
}

.folder-use-badge {
    position: absolute;
    top: 2px;
    right: 2px;
    background: rgba(0, 0, 0, 0.65);
    color: #fff;
    font-size: 10px;
    padding: 1px 4px;
    border-radius: 2px;
    line-height: 1.2;
}

.image-slot {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #bbb;
    font-size: 20px;
}

.folder-meta {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 2px 0;
}

.folder-name {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    line-height: 18px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: keep-all;
    word-wrap: normal;
    width: 10px;
}

.folder-time {
    margin-top: 2px;
    color: #999;
    font-size: 11px;
    margin-bottom: 6px;
}

.folder-settings {
    margin-top: 4px;
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.folder-setting-item {
    display: flex;
    align-items: center;
    font-size: 11px;
    color: #666;
    line-height: 16px;
}

.folder-setting-item .setting-text {
    color: #909399;
    margin-right: 4px;
}

.folder-setting-item .setting-value {
    color: #409eff;
    font-weight: 500;
}

.files-main {
    padding: 0px 5px !important;
    overflow: hidden !important;
    height: 100%;
}

.files-main-full {
    padding: 0px 5px !important;
    width: 100%;
    overflow: hidden !important;
    height: 100%;
}

.files-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.files-card>>>.el-card__header {
    flex-shrink: 0;
}

.files-card>>>.el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0;
}

.files-card-header {

    display: flex;
    justify-content: space-between;
}

.files-header-left {
    display: flex;
    align-items: center;
    gap: 6px;
}

.files-total-inline {
    color: #909399;
    font-size: 12px;
    margin-left: 8px;
}

.files-header-right {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

/* 文件夹设置信息 */
.folder-settings-info {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 20px;
    align-items: center;
    padding: 12px 16px;
    background: linear-gradient(135deg, #e8f4fd 0%, #f0f9ff 100%);
    border-left: 3px solid #409eff;
    border-radius: 4px;
    margin: 0 20px 12px 20px;
    flex-shrink: 0;
}

.setting-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    flex-shrink: 0;
}

.setting-item i {
    color: #409eff;
    font-size: 15px;
}

.setting-label {
    color: #606266;
    font-weight: 500;
    white-space: nowrap;
}

.setting-unit {
    color: #909399;
    font-size: 12px;
    white-space: nowrap;
    margin-left: 4px;
}

.files-scroll {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 20px;
    box-sizing: border-box;
    min-height: 0;
}

.files-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    color: #666;
    font-size: 12px;
    border-top: 1px solid #ebeef5;
    background: #fff;
    flex-shrink: 0;
}

/* 设置内容 */
.settings-content {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
}

.setting-description {
    color: #909399;
    font-size: 12px;
    line-height: 1.5;
}

/* 修复 radio 组件的无障碍访问警告 */
.settings-content>>>.el-radio__original[aria-hidden="true"] {
    pointer-events: none;
}

/* 保存设置按钮容器 */
.save-settings-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    border-top: 1px solid #ebeef5;
    background: #fafafa;
    margin-top: 6px;
}

.unsaved-tip {
    color: #e6a23c;
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.unsaved-tip i {
    font-size: 14px;
}

.file-thumb {
    width: 60px;
    height: 36px;
    background: #fafafa;
    border-radius: 3px;
}

.image-slot-small {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #bbb;
}

.current-folder {
    color: #666;
    font-size: 12px;
    margin-left: 6px;
}

/* 字幕对话框样式 */
.subtitle-dialog-content {
    max-height: 60vh;
    overflow-y: auto;
    padding: 10px 0;
}

.subtitle-list {
    margin-bottom: 16px;
}

.subtitle-item {
    padding: 10px;
    background: #fafafa;
    border-radius: 6px;
    margin-bottom: 12px;
}

.subtitle-item:last-child {
    margin-bottom: 0;
}

.subtitle-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.subtitle-item-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
}

.subtitle-actions {
    text-align: center;
    padding: 12px 0;
    border-top: 1px solid #ebeef5;
}

/* 字幕卡片列表样式 */
.empty-text {
    text-align: center;
    padding: 40px 0;
    color: #909399;
    font-size: 14px;
}

.subtitle-card-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.subtitle-card-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.subtitle-card-item:hover {
    border-color: #409eff;
    box-shadow: 0 2px 12px rgba(64, 158, 255, 0.1);
    background: #f5f7fa;
}

.subtitle-card-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.subtitle-preview-text {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #303133;
    line-height: 1.5;
}

.subtitle-card-meta {
    display: flex;
    align-items: center;
    gap: 12px;
}

.subtitle-time {
    font-size: 12px;
    color: #909399;
}

.subtitle-card-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 16px;
}

.file-thumb-wrapper {
    position: relative;
    width: 60px;
    height: 36px;
    cursor: pointer;
}

.file-thumb-wrapper .file-thumb {
    width: 100%;
    height: 100%;
}

.file-thumb-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.35);
    border-radius: 3px;
    color: #fff;
    font-size: 20px;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.file-thumb-wrapper:hover .file-thumb-overlay {
    opacity: 1;
}

.file-thumb-overlay i {
    color: #fff;
    font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/User/workflow_files.vue


// WEBPACK FOOTER //
// src/components/User/workflow_files.vue